import {ChildEntity} from "typeorm";
import {Notification} from "@/modules/notifications/entity";
import CoinsPurchasedNotificationComponent from "@/modules/action-points/components/CoinsPurchasedNotification.vue";
import {Component} from "@vue/runtime-core";
import {ShallowRef} from "vue";

@ChildEntity()
export class CoinsPurchasedNotification extends Notification {
  setPayload(coins: number) {
    this.payloadRaw = JSON.stringify({coins});

    return this;
  }

  get payload(): { coins: number } {
    return JSON.parse(this.payloadRaw!);
  }

  get component(): ShallowRef<Component> {
    return shallowRef(CoinsPurchasedNotificationComponent);
  }
}